import React from 'react';
import styled from 'styled-components';
import RoomLocationGuideModal from '../custom/modal/RoomLocationGuideModal';

const LocationGuide = () => {
	return (
		<Container>
			<RoomLocationGuideModal standalone />
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	height: 100%;
`;

export default LocationGuide;
